import { getEnvAsBool, getEnvAsInt } from "./environment";
import {
  STATE_BATTERY_UNKNOWN,
  STATE_CLAIM_UNKNOWN,
  STATE_MOTOR_UNKNOWN,
  STATE_ROBOT_DISCONNECTED,
} from "./state";

export const PUBSUB_SOURCE = process.env.REACT_APP_PUBSUB_SOURCE;

export const DEFAULT_HOST =
  process.env.REACT_APP_JETPACK_HOST_OVERRIDE || `${window.location.hostname}`;

export const DEFAULT_CONTROL_PORT = getEnvAsInt(
  "REACT_APP_JETPACK_CONTROL_PORT_OVERRIDE",
  3000
);
export const DEFAULT_VIDEO_PORT =
  process.env.REACT_APP_JETPACK_VIDEO_PORT_OVERRIDE || 9002;
export const DEFAULT_SPEAKER_PORT =
  process.env.REACT_APP_JETPACK_SPEAKER_PORT_OVERRIDE || 9003;
export const DEFAULT_WEBSERVER_PORT =
  process.env.REACT_APP_JETPACK_WEBSERVER_PORT_OVERRIDE || window.location.port;

export const IS_DEV = process.env.NODE_ENV === "development";

export const COMPACT_MODE = getEnvAsBool("REACT_APP_COMPACT_MODE", false);

// config mode
export const MODE_SIT = "SIT";
export const MODE_STAND = "STAND";
export const MODE_WALK = "WALK";
export const MODE_CRAWL = "CRAWL";
export const MODE_STAIR = "STAIR";
export const MODE_STANDARD = "STANDARD";

export const SPEED_SLOW = 0.2;
export const SPEED_NORMAL = 1.0;
export const SPEED_FAST = 2;
export const SPEED_STEP = 0.2;

export const HEIGHT_ACTUAL = 0.61;
export const HEIGHT_DEFAULT = 0;
export const HEIGHT_MIN = -0.09;
export const HEIGHT_MAX = 0.09;
export const HEIGHT_STEP = 0.03;

// arm control modes
export const ARM_STOW = "Stow";
export const ARM_UNSTOW = "Unstow";
export const ARM_CARRY = "Carry";
export const ARM_AUTO_GRIP = "ARM_AUTO_GRIP";
export const ARM_MANIP_VALVE_TURN = "ARM_MANIP_VALVE_TURN";
export const ARM_MANIP_MANUAL = "ARM_MANIP_MANUAL";

// arm grip defaults
export const ARM_DEFAULT_GRIP_DEPTH = 0.3;
export const ARM_DEFAULT_GRIP_TORQUE = 0.1;

export const ARM_TORQUE_MIN = 0;
export const ARM_TORQUE_MAX = 20.0;
export const ARM_TORQUE_STEP = 1;
export const ARM_GRIP_DEPTH_MIN = 0.1;
export const ARM_GRIP_DEPTH_MAX = 0.7;
export const ARM_GRIP_DEPTH_STEP = 0.1;

export const LIGHT_DEFAULT = 0;
export const LIGHT_MIN = 0;
export const LIGHT_MAX = 100;
export const LIGHT_STEP = 1;

export const AVOID_DEFAULT = 0.2;
export const AVOID_MIN = 0.05;
export const AVOID_MAX = 1.0;
export const AVOID_STEP = 0.05;

export const LOGIN_NOT_CONNECTED = 0;
export const LOGIN_CONNECTING = 1;
export const LOGIN_CONNECTED = 2;

export const STREAM_LOW_FPS = 5;

export const DISABLE_ACTION = true;

export const DEFAULT_ARM_STATE = {
  armMode: ARM_STOW,
  armJointPos: null,
  armGripperPos: {},
  hasArm: false,
  armGripDepth: 0.3,
  armTorque: 4,
  armEndEffectorState: {},
};

export const DEFAULT_PTZ_STATE = {
  hasPTZ: true,
  pan: 90,
  tilt: 90,
  zoom: 0.0,
};

export const DEFAULT_ROBOT_STATE = {
  robotMode: MODE_SIT,
  robotHeight: 0,
  robotConnectionState: STATE_ROBOT_DISCONNECTED,
  motorState: STATE_MOTOR_UNKNOWN,
  estopState: { software: false, hardware: false },
  maxSpeed: 0,
  batteryPercent: 0,
  batteryStatus: STATE_BATTERY_UNKNOWN,
  batteryTemperature: 0,
  motorClaimState: STATE_CLAIM_UNKNOWN,
  eStopClaimState: STATE_CLAIM_UNKNOWN,
  proximities: [],
};

export const HAS_INSPECTION = getEnvAsBool("REACT_APP_HAS_INSPECTION", false);
